module.exports = __webpack_public_path__ + "static/media/upiQRCode.d0e76655.jpg";